<template>
    <div>
        <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            style="margin-bottom: 10px"
        >
            新增配置
        </el-button>
        <filter-box
            channel="union"
            @reset="resetEvent"
            @search="searchEvent"
        ></filter-box>
        <div class="tableList">
            <!-- 表格部分 -->
            <el-table
                v-loading="tableLoading"
                :data="tableData"
                style="width: 100%"
                class="table-box"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: '#606266',
                }"
            >
                <el-table-column
                    prop="member_id"
                    label="用户ID(旧会员ID)"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    prop="merchant_id"
                    label="服务商商户号(mchid)"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="terminal_code"
                    label="终端号"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="msg_src"
                    label="消息来源"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="msg_src_id"
                    label="来源编号"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="sign"
                    label="MD5密钥"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="appid"
                    label="pos支付appid"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="appkey"
                    label="pos支付appkey"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="支付模式"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        {{ ["公众号", "被扫支付(B扫C)", "二维码主扫(C扫B)"][+scope.row.type] }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="encryption_mode"
                    label="公众号支付加密模式"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        {{ ["md5", "sha256"][+scope.row.encryption_mode] }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="editWechat(scope.row)"
                        >
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="page-box">
                <el-pagination
                    @current-change="fetchList"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <union-dialog
            :visible.sync="dialogVisible"
            :actionType="dialogType"
            :config="currentRow"
            @refresh="refreshList"
        ></union-dialog>
    </div>
</template>

<script>
import { getMerchantUnionList } from "@/api/config";
import FilterBox from "./components/filterBox.vue";
import UnionDialog from "./components/unionDialog.vue";

export default {
    components: {
        FilterBox,
        UnionDialog,
    },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            tableLoading: false,
            tableData: [],
            searchParams: {
                use_env: "3",
                member_id: "",
            },
            dialogVisible: false,
            dialogType: "add",
            currentRow: null,
        };
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        async fetchList() {
            let { page, pageSize } = this;
            let { use_env, member_id } = this.searchParams;
            let params = {
                page,
                page_size: pageSize,
                use_env,
                member_id,
            };
            this.tableLoading = true;
            const res = await getMerchantUnionList(params);
            this.tableLoading = false;
            if (res.code != 200) return;
            let { list, total } = res.data;
            this.tableData = list || [];
            this.total = parseInt(total);
        },
        addEvent() {
            this.dialogVisible = true;
            this.dialogType = "add";
        },
        resetEvent(params) {
            this.searchParams = params;
        },
        searchEvent(params) {
            let { use_env, member_id } = params;
            if (!use_env && !member_id)
                return this.$message.error("请输入搜索条件");
            this.page = 1;
            this.searchParams = params;
            this.fetchList();
        },
        editWechat(val) {
            this.currentRow = val;
            this.dialogType = "edit";
            this.dialogVisible = true;
        },
        refreshList() {
            if (this.dialogType === "add") {
                this.page = 1;
                this.fetchList();
            } else {
                this.fetchList();
            }
        },
    },
};
</script>

<style lang="scss"></style>
